module.exports = __webpack_public_path__ + "img/livepen-16g.31b160ce.png";